import { bindMunicipalitySelect } from './municipality_select'

export function initSubsidyAreaTopForm(root = document) {
  const forms = root.querySelectorAll('.js-subsidy-area-top-filters')

  forms.forEach((form) => {
    if (form.dataset.subsidyAreaTopInitialized === 'true') {
      return
    }

    const partHiddenInputs = form.querySelector('[data-part-hidden-inputs]')
    const partChipButtons = Array.from(form.querySelectorAll('[data-part-chip]'))

    form.dataset.subsidyAreaTopInitialized = 'true'
    bindMunicipalitySelect(form)
    bindArticleSearch(form, () => {
      form.reset()
      partChipButtons.forEach((button) => setPartChipPressed(button, readPartTags(button).length === 0))
      syncPartHiddenInputs(partChipButtons, partHiddenInputs)
    })

    partChipButtons.forEach((button) => {
      if (!(button instanceof HTMLButtonElement)) {
        return
      }

      button.addEventListener('click', () => {
        const tags = readPartTags(button)
        const isUnsetChip = tags.length === 0

        if (isUnsetChip) {
          partChipButtons.forEach((chipButton) => {
            if (chipButton instanceof HTMLButtonElement) {
              setPartChipPressed(chipButton, chipButton === button)
            }
          })
          syncPartHiddenInputs(partChipButtons, partHiddenInputs)
          return
        }

        setPartChipPressed(button, button.getAttribute('aria-pressed') !== 'true')

        partChipButtons.forEach((chipButton) => {
          if (chipButton instanceof HTMLButtonElement && readPartTags(chipButton).length === 0) {
            setPartChipPressed(chipButton, false)
          }
        })

        const hasActivePartChip = partChipButtons.some((chipButton) => {
          return chipButton instanceof HTMLButtonElement
            && readPartTags(chipButton).length > 0
            && chipButton.getAttribute('aria-pressed') === 'true'
        })

        if (!hasActivePartChip) {
          partChipButtons.forEach((chipButton) => {
            if (chipButton instanceof HTMLButtonElement && readPartTags(chipButton).length === 0) {
              setPartChipPressed(chipButton, true)
            }
          })
        }

        syncPartHiddenInputs(partChipButtons, partHiddenInputs)
      })
    })
  })
}

function bindArticleSearch(form, resetFilters) {
  if (!form.hasAttribute('data-subsidy-article-search')) {
    return
  }

  const root = form.ownerDocument
  const results = root.getElementById('subsidy-article-search-results')
  const content = root.querySelector('[data-subsidy-article-content]')
  const nav = root.querySelector('[data-subsidy-article-nav]')
  const reset = root.querySelector('[data-subsidy-search-reset]')
  const loading = form.querySelector('[data-subsidy-search-loading]')
  const error = form.querySelector('[data-subsidy-search-error]')
  if (!results || !content || !nav || !reset || !loading || !error) {
    return
  }

  root.addEventListener('htmx:beforeRequest', (event) => {
    if (event.detail?.target !== results) return
    loading.hidden = false
    error.hidden = true
    reset.disabled = true
    results.setAttribute('aria-busy', 'true')
  })
  root.addEventListener('htmx:afterRequest', (event) => {
    if (event.detail?.target !== results) return
    loading.hidden = true
    reset.disabled = false
    results.setAttribute('aria-busy', 'false')
  })
  root.addEventListener('htmx:afterSwap', (event) => {
    if (event.detail?.target !== results) return
    content.hidden = true
    nav.hidden = true
    reset.hidden = false
    const heading = results.querySelector('h2')
    if (heading) {
      heading.tabIndex = -1
      heading.focus({preventScroll: true})
    }
    reset.scrollIntoView({block: 'start'})
  })
  for (const eventName of ['htmx:responseError', 'htmx:sendError', 'htmx:timeout']) {
    root.addEventListener(eventName, (event) => {
      if (event.detail?.target !== results) return
      error.hidden = false
      error.scrollIntoView({block: 'center'})
    })
  }

  reset.addEventListener('click', () => {
    resetFilters()
    results.replaceChildren()
    reset.hidden = true
    error.hidden = true
    content.hidden = false
    nav.hidden = false
    content.tabIndex = -1
    content.focus({preventScroll: true})
    content.scrollIntoView({block: 'start'})
  })
}

function readPartTags(button) {
  try {
    const tags = JSON.parse(button.dataset.partTags || '[]')
    return Array.isArray(tags) ? tags.filter((tag) => typeof tag === 'string' && tag !== '') : []
  } catch (_error) {
    return []
  }
}

function setPartChipPressed(button, pressed) {
  button.setAttribute('aria-pressed', pressed ? 'true' : 'false')
}

function syncPartHiddenInputs(partChipButtons, partHiddenInputs) {
  if (!(partHiddenInputs instanceof HTMLElement)) {
    return
  }

  const selectedTags = []
  partChipButtons.forEach((button) => {
    if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-pressed') !== 'true') {
      return
    }

    readPartTags(button).forEach((tag) => {
      if (!selectedTags.includes(tag)) {
        selectedTags.push(tag)
      }
    })
  })

  partHiddenInputs.innerHTML = ''
  selectedTags.forEach((tag) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'part[]'
    input.value = tag
    partHiddenInputs.appendChild(input)
  })
}

if (typeof document !== 'undefined') {
  initSubsidyAreaTopForm()
}
